// GoogleAuth.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const GoogleAuth = () => {
  const navigate = useNavigate();

  const handleGoogleLogin = () => {
    // Simulate Google Authentication process
    console.log('Google login successful!');

    // Redirect to NotebookHome after login
    navigate('/notebookhome');
  };

  return (
    <div style={styles.container}>
      <h1>Google Authentication</h1>
      <p>Sign in with your Google account to continue.</p>
      <button onClick={handleGoogleLogin} style={styles.button}>
        Login with Google
      </button>
    </div>
  );
};

const styles = {
  container: {
    textAlign: 'center',
    padding: '20px',
    maxWidth: '400px',
    margin: '0 auto',
  },
  button: {
    padding: '10px 20px',
    backgroundColor: '#4285F4',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    fontSize: '1rem',
    cursor: 'pointer',
  },
};

export default GoogleAuth;
